import React, {useEffect, useLayoutEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PaymentDetailsRow from './sections/payment-details-row';
import PaymentDetailsQuantityRow from './sections/payment-details-quantity-row';
import PaymentDetailsRangeRow from './sections/payment-details-range-row';
import Loader from '../../../../components/common/loader';
import Checkbox from '../../../../components/forms/checkbox';
import {BenefitType, UpsalePopupStatus} from '../../../../app/enums';
import {
    combineClassNames,
    createAnalyticsItemsList,
    formatPrice,
    getMediaPath,
    interpolate,
    getUpsalePopupStatus,
    reactParserCommonOptions    

} from '../../../../app/functions';
import closeIconPath from '../../../../assets/icons/login-x-icon.svg';
import percentageTagIcon from '../../../../assets/icons/percentage-tag-icon.svg';
import cb_checked_mobile from '../../../../assets/icons/checkbox-checked-purple-mobile.svg';
import cb_checked from '../../../../assets/icons/checkbox-check-purple.svg';
import cb from '../../../../assets/icons/checkbox-purple.svg';
import './index.scss';
import {acquirePaidCoupon, getAvailabaleCoupons} from 'redux/actions/actions_requests'
import {addPopup} from "../../../../redux/actions";
import * as Popups from '../../../../constants/popup-types';
import * as Routes from '../../../../constants/routes';
import {useHistory} from "react-router-dom";
import AnalyticsManager from "../../../../app/analytics";
import {trackFbq} from '../../../../app/analytics';
import ReactHtmlParser from 'react-html-parser';
import { OTP_PROCESS } from 'pages/personal-zone/utils/enums';
import HtmlCheckbox from '../../../../components/forms/htmlCheckbox';

const NewPaymentPopup = ({benefitId, benefitType, benefit, handleClose, title, image}) => {
    // Redux
    const dispatch = useDispatch();
    const userData = useSelector((store) => store.config.UserData);
    const translations = useSelector((store) => store.config.Translations);
    const deviceState = useSelector((store) => store.state.deviceState);

    const history = useHistory();
    // Popup State
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [isInitialLoading, setIsInitialLoading] = useState(true);
    const [isProcessing, setIsProcessing] = useState(false);

    // Imma shel michael
    const [benefitData, setBenefitData] = useState();
    const [paymentOptions, setPaymentOptions] = useState();


    // Payment State
    const [selectedQuantity, setSelectedQuantity] = useState(1);
    const [quantityError, setQuantityError] = useState(null);
    const [selectedRange, setSelectedRange] = useState(paymentOptions?.['rangeDefault']);
    const [rangeError, setRangeError] = useState(null);
    const [marketingConsentCheckbox, setMarketingConsentCheckbox] = useState(false);
    const [marketingLinkClicked, setMarketingLinkClicked] = useState(false);
    const [showMarketingLinkNotClickedError, setShowMarketingLinkNotClickedError] = useState(false);

    // Device State
    const isMobile = (deviceState === 'mobile');
    const isMobileOrTablet = (deviceState === 'mobile' || deviceState === 'tablet');

    // Popup Information
    const shouldDisplayLoader = (isInitialLoading || isProcessing);

    // User Information
    const defaultCreditCard = userData['cardsArr'].find((card) => card.active && card.default) || {};

    // Benefit Information
    const isPaidCoupon = (benefitType == BenefitType.PAID_COUPON);
    const isPurchaseVoucher = (benefitType == BenefitType.PURCHASE_VOUCHER);
    const isEligibleBenefitForMarketingCheckbox = (benefitType == BenefitType.PAID_COUPON || benefitType == BenefitType.PURCHASE_VOUCHER);
    const showMarketingCheckbox = isEligibleBenefitForMarketingCheckbox && !userData?.maStatus;

    // Payment Information
    const isFixedPricing = typeof paymentOptions?.minimumCoupons !== 'undefined' &&
        typeof paymentOptions?.maximumCoupons !== 'undefined';
    const isRangePricing = typeof paymentOptions?.rangeMinimum !== 'undefined' &&
        typeof paymentOptions?.rangeMaximum !== 'undefined';
    const allowChoosingQuantity = (
        typeof paymentOptions?.['minimumCoupons'] !== 'undefined' &&
        paymentOptions?.['minimumCoupons'] < paymentOptions?.['maximumCoupons']
    );
    const calculatedPrices = (() => {
        let originalPriceForQuantity = NaN, actualPriceForQuantity = NaN, priceDifferences = NaN;

        if (isFixedPricing) {
            originalPriceForQuantity = paymentOptions?.['originalPrice'] * selectedQuantity;
            actualPriceForQuantity = paymentOptions?.['actualPrice'] * selectedQuantity;
            priceDifferences = originalPriceForQuantity - actualPriceForQuantity;
        }

        if (isRangePricing) {
            originalPriceForQuantity = selectedRange * selectedQuantity;
            actualPriceForQuantity = (
                selectedRange - (paymentOptions?.['discountPercentage'] / 100) * selectedRange
            ) * selectedQuantity;
            priceDifferences = originalPriceForQuantity - actualPriceForQuantity;
        }

        originalPriceForQuantity = formatPrice(originalPriceForQuantity);
        actualPriceForQuantity = formatPrice(actualPriceForQuantity);
        priceDifferences = formatPrice(priceDifferences);

        return {originalPriceForQuantity, actualPriceForQuantity, priceDifferences};
    })();

    // Others
    const replacementsObject = {
        ...benefitData, ...paymentOptions, ...calculatedPrices,
        lastDigits: defaultCreditCard['last_digits']
    };

    const dispatchSubsidyPopup = (content, status, benefit) => {
        const { relatedBenefits, main: { title, upsell_popup_footer_text } } = benefit;
        dispatch(addPopup({
            type: Popups.SUBSIDY_POPUP,
            content,
            header: title,
            benefits: relatedBenefits,
            status,
            footerText: upsell_popup_footer_text
        }));
    };

    // --------------------------------
    // Popup Functions
    // --------------------------------

    const openPopup = () => {
        const onSuccess = (data) => {
            const {
                logo,
                maxPayments,
                availableStock,
                discountPercentage,
                discountDescription,
                minimumBudget,
                maximumBudget,
                minimumCoupons,
                maximumCoupons,
                originalPrice,
                actualPrice,
                budgetStep,
                initialBudget,
                dailyLimit,
                weeklyLimit,
                monthlyLimit,
                overallLimit,
                successMessage
            } = data;
            const isRange = typeof maximumBudget !== 'undefined' && typeof minimumBudget !== 'undefined';
            const rangeDefault = isRange ? (initialBudget - initialBudget % budgetStep) : undefined;
            setBenefitData({
                title,
                image: logo || image || '',
            });
            setSelectedRange(rangeDefault);
            setPaymentOptions({
                discountPercentage,
                rangeMinimum: minimumBudget,
                rangeMaximum: maximumBudget,
                rangeStep: budgetStep,
                rangeDefault: rangeDefault,
                dailyLimit,
                monthlyLimit,
                overallLimit,
                weeklyLimit,
                minimumCoupons,
                maximumCoupons,
                originalPrice,
                actualPrice,
                successMessage
            })
        };
        const onFailure = (err) => {
            handleClose();
            if (benefit?.is_subsidized) {
                const status = getUpsalePopupStatus(err.status);
                AnalyticsManager.logUpsalePopupPresented(status);
                const itemsList = createAnalyticsItemsList(benefit.relatedBenefits, {
                    item_list_name: 'upsale_popup'
                });

                AnalyticsManager.logUpsalePopupViewedItemList(itemsList);

                dispatchSubsidyPopup(
                    err.content, 
                    status,
                    benefit,
                );
            } else {
                if (benefit.relatedBenefits) {
                    dispatchSubsidyPopup(
                        err.content || translations['upsell_popup_purchase_error_title'],
                        UpsalePopupStatus.NO_INVENTORY,
                        benefit,
                    );
                } else {
                    dispatch(addPopup({
                        type: Popups.GENERAL_MESSAGE,
                        text: ReactHtmlParser(err.content, reactParserCommonOptions()),
                    }));
                }
            }
        };
        dispatch(getAvailabaleCoupons({benefitId}, {
            onSuccess,
            onFailure,
        }));
        setIsPopupVisible(true);
    }

    const closePopup = () => {
        if (isProcessing) return;
        setIsPopupVisible(false);
        setTimeout(handleClose, 250);
    };

    const handleBackdropClick = () => {
        // closePopup();
    };

    // --------------------------------
    // Payment Functions
    // --------------------------------

    const handleQuantityChange = (newQuantity) => {
        if (newQuantity < 1) return;

        setQuantityError(null);
        // Validate the selected quantity is not higher than the TOTAL maximum allowed
        if (newQuantity === paymentOptions?.['maximumCoupons']) {
            const keysByOrder = [
                'dailyLimit',
                'weeklyLimit',
                'monthlyLimit',
                'yearlyLimit',
                'overallLimit',
            ];
            let res = [];
            keysByOrder.forEach(limit => {
                if (!isNaN(paymentOptions[limit]) && paymentOptions[limit] > 0) {
                    res.push(
                        interpolate(translations[`payment_limit_error_${limit.replace('Limit', '')}`], {
                            [limit]: paymentOptions[limit],
                        }),
                    );
                }
            });
            if (res.length > 0) {
                setQuantityError(`${translations['payment_limit_error_start']} ${res.join(', ')}`);
            }
        }

        setSelectedQuantity(newQuantity);
    };

    const handleCheckboxLinkClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setShowMarketingLinkNotClickedError(false);
        setMarketingLinkClicked(true);
        const url = event.currentTarget.href;
        if (url) {
            dispatch(addPopup({
                type: Popups.IFRAME_POPUP,
                iframeUrl: url,
            }));
        }
    };

    const handleRangeChange = (newRange) => {
        if (selectedRange === newRange) return true;

        // Validate the selected range is not lower/higher than the minimum/maximum allowed
        if (
            newRange < paymentOptions?.['rangeMinimum'] ||
            newRange > paymentOptions?.['rangeMaximum']
        ) {
            setSelectedRange(
                Math.max(
                    paymentOptions?.['rangeMinimum'],
                    Math.min(
                        paymentOptions?.['rangeMaximum'],
                        (newRange / paymentOptions?.['rangeStep']) * paymentOptions?.['rangeStep']
                    )
                )
            );
            setRangeError(
                interpolate(translations['payment_out_of_range_error'], replacementsObject)
            );
            return false;
        }

        // Validate the selected range is a multiple of the step
        if (newRange % paymentOptions?.['rangeStep'] !== 0) {
            setSelectedRange(
                Math.floor(newRange / paymentOptions?.['rangeStep']) * paymentOptions?.['rangeStep']
            );
            setRangeError(
                interpolate(translations['payment_range_was_rounded_error'], replacementsObject)
            );
            return false;
        }

        setSelectedRange(newRange);
        setRangeError(null);
        return true;
    };

    const handleAcquireClick = () => {
        setIsProcessing(true);
        dispatch(addPopup({
            type: Popups.PHONE_VALIDATION,
            phone: userData.phone,
            userId: userData.user_id,
            process: OTP_PROCESS.VERIFY,
            data: {
                userId: userData.user_id,
                is_first_login: false,
            },
            onCancel: () => setIsProcessing(false),
            action: (a) => {
                const hasBudget =
                    typeof paymentOptions['rangeMinimum'] !== 'undefined' &&
                    typeof paymentOptions['rangeMaximum'] !== 'undefined';
                const voucherQuantity = hasBudget ? 1 : selectedQuantity;
                const voucherPrice = hasBudget ? selectedRange : paymentOptions['originalPrice'];
                const couponNum = isPaidCoupon ? selectedQuantity : voucherQuantity;
                const couponValue = isPaidCoupon ? paymentOptions['originalPrice'] : voucherPrice;
                const successMessage = paymentOptions['successMessage'];
                const acquirePayload = {
                    benefitId,
                    paymentsNum: 1,
                    couponValue,
                    couponNum,
                };
                if (showMarketingCheckbox) {
                    acquirePayload.marketingCheckbox = marketingConsentCheckbox;
                }
                dispatch(acquirePaidCoupon(acquirePayload, (data) => {
                    handleClose();
                    const transactionId = `${benefitId}-${data?.order_id}`;
                    AnalyticsManager.logPurchase(createAnalyticsItemsList([
                        {...benefit, quantity: couponNum, price: couponValue},
                    ]), couponValue * couponNum, transactionId);
                    AnalyticsManager.logBenefitPaidCouponSuccess(benefitId, couponValue);

                    if(benefit.is_subsidized) {
                        trackFbq('Purchase_tav');
                    }
                    
                    if (benefit.is_subsidized && benefit.relatedBenefits?.length > 0) {
                        AnalyticsManager.logUpsalePopupPresented(UpsalePopupStatus.SUCCESSFUL_PURCHASE);
                        const itemsList = createAnalyticsItemsList(benefit.relatedBenefits, {
                            item_list_name: 'upsale_popup'
                        })
                        AnalyticsManager.logUpsalePopupViewedItemList(itemsList);
                        dispatchSubsidyPopup(
                            successMessage,
                            UpsalePopupStatus.SUCCESSFUL_PURCHASE,
                            benefit,
                        );
                    } else if (!benefit.is_subsidized) {
                        if (benefit.relatedBenefits) {
                            dispatchSubsidyPopup(
                                benefit.main.upsell_popup_header_text || translations['upsell_popup_purchase_success_title'],
                                UpsalePopupStatus.SUCCESSFUL_PURCHASE,
                                benefit,
                            );
                        } else {
                            dispatch(addPopup({
                                type: Popups.ACQUIRED,
                                benefitId: benefitId,
                                isAcquired: false,
                                purchased: true,
                                action: () => history.push(Routes.home)
                            }));
                        }
                    }
                }, () => {
                    setIsProcessing(false);
                }, benefit, translations, handleClose));
            },
        }));
    };

    // --------------------------------
    // Popup Effects
    // --------------------------------

    useLayoutEffect(openPopup, []);

    useEffect(() => {
        if (isPopupVisible && benefitData && paymentOptions) {
            setIsInitialLoading(false);
        }
    }, [isPopupVisible, benefitData, paymentOptions]);

    // --------------------------------
    // Sub-Components
    // --------------------------------

    return (

        <div
            className={combineClassNames('backdrop', isPopupVisible && 'active')}
            onClick={handleBackdropClick}
        >
            <div className={combineClassNames('new-payment-popup', isPopupVisible && 'new-payment-popup_active')}
                 onClick={e => e.stopPropagation()}>
                <button type="button" className="popup-close-button" onClick={closePopup} aria-label="Close Popup">
                    <img src={closeIconPath} alt="Close Icon"/>
                </button>

                <div className="popup-content">
                    {!isInitialLoading && (
                        <>
                            <img src={getMediaPath(benefitData['image'])} alt={benefitData['title']}
                                 className="benefit-banner"/>

                            <h2 className="benefit-title">
                                {benefitData['title']}
                            </h2>

                            {/* ---- BEGINNING OF PAYMENT DETAILS ---- */}
                            <section className="payment-details">
                                {/* ---- PAID COUPONS ---- */}
                                {isPaidCoupon && (
                                    <>
                                        {/* Single Coupon Price */}
                                        <PaymentDetailsRow
                                            label={interpolate(translations['payment_paid_coupon_price_label'], replacementsObject)}
                                            value={paymentOptions['actualPrice']}
                                            erasedValue={paymentOptions['originalPrice']}
                                        />

                                        {/* Coupon Quantity */}
                                        {allowChoosingQuantity && (
                                            <PaymentDetailsQuantityRow
                                                value={selectedQuantity}
                                                error={quantityError}
                                                onValueChange={handleQuantityChange}
                                                min={paymentOptions['minimumCoupons']}
                                                max={paymentOptions['maximumCoupons']}
                                            />
                                        )}

                                        <PaymentDetailsTotalSaved replacementsObject={replacementsObject}
                                                                  text={translations['payment_total_saved_label']}/>

                                        {/* Coupon Total Price */}
                                        <PaymentDetailsRow
                                            label={interpolate(translations['payment_total_actual_price_label'], replacementsObject)}
                                            value={calculatedPrices['actualPriceForQuantity']}
                                            boldLabel
                                        />
                                    </>
                                )}

                                {/* ---- PURCHASE VOUCHERS ---- */}
                                {isPurchaseVoucher && (
                                    <>
                                        {/* Fixed Pricing */}
                                        {isFixedPricing && (
                                            <>
                                                {/* Voucher Original Price */}
                                                <PaymentDetailsRow
                                                    boldValue={false}
                                                    label={interpolate(translations['payment_purchase_voucher_original_price_label'], replacementsObject)}
                                                    value={paymentOptions['originalPrice']}
                                                />

                                                {/* Voucher Actual Price */}
                                                <PaymentDetailsRow
                                                    label={interpolate(translations['payment_purchase_voucher_actual_price_label'], replacementsObject)}
                                                    value={paymentOptions['actualPrice']}
                                                />

                                                {/* Voucher Quantity */}
                                                {allowChoosingQuantity && (
                                                    <PaymentDetailsQuantityRow
                                                        max={paymentOptions?.['maximumCoupons']}
                                                        min={paymentOptions?.['minimumCoupons']}
                                                        value={selectedQuantity}
                                                        error={quantityError}
                                                        onValueChange={handleQuantityChange}
                                                    />
                                                )}
                                                <PaymentDetailsRow
                                                    label={interpolate(translations['voucher_slider_monthly_limit'], {monthlyLimit: formatPrice(replacementsObject.monthlyLimit, 0)})}
                                                />
                                            </>
                                        )}

                                        {/* Range Pricing */}
                                        {isRangePricing && (
                                            <PaymentDetailsRangeRow
                                                value={selectedRange}
                                                error={rangeError}
                                                onValueChange={handleRangeChange}
                                                minimumValue={paymentOptions['rangeMinimum']}
                                                maximumValue={paymentOptions['rangeMaximum']}
                                                stepValue={paymentOptions['rangeStep']}
                                                monthlyLimit={paymentOptions.monthlyLimit}
                                            />
                                        )}

                                        <div className="payment-details-divider"/>

                                        {/* Voucher Original Price for Quantity */}
                                        {isFixedPricing && (
                                            <PaymentDetailsRow
                                                boldValue={false}
                                                label={interpolate(translations['payment_total_original_price_label'], replacementsObject)}
                                                value={calculatedPrices['originalPriceForQuantity']}
                                            />
                                        )}

                                        {/* Voucher Actual Price for Quantity */}
                                        <PaymentDetailsRow
                                            label={interpolate(translations['payment_total_actual_price_with_percentage_label'], replacementsObject)}
                                            value={calculatedPrices['actualPriceForQuantity']}
                                            boldLabel
                                            isCentered={isMobile}
                                        />

                                        <PaymentDetailsTotalSaved isCentered={isMobile}
                                                                  replacementsObject={replacementsObject}
                                                                  text={translations['payment_total_saved_label']}/>
                                    </>
                                )}
                            </section>
                            {/* ---- END OF PAYMENT DETAILS ---- */}

                            <section
                                className={combineClassNames('payment-actions', isPaidCoupon && 'payment-actions_spaced')}>
                                <p className="payment-actions-credit-card">
                                    {interpolate(translations['payment_selected_credit_card_message'], replacementsObject)}
                                </p>

                                {showMarketingCheckbox && (
                                    <div className="payment-actions-marketing-checkbox">
                                        <HtmlCheckbox
                                            name="marketing-consent"
                                            html={translations['consents_marketing_checkbox_html']}
                                            value={marketingConsentCheckbox}
                                            onChange={(checked) => setMarketingConsentCheckbox(checked)}
                                            handleLinkClick={handleCheckboxLinkClick}
                                            disableCheckbox={!marketingLinkClicked}
                                            onDisabledClicked={() => setShowMarketingLinkNotClickedError(true)}
                                            checked_img={isMobileOrTablet ? getMediaPath(cb_checked_mobile) : getMediaPath(cb_checked)}
                                            not_checked_img={getMediaPath(cb)}
                                            className="payment-marketing-cb"
                                        />
                                        {showMarketingLinkNotClickedError && (
                                            <p className="payment-actions-checkbox-error">
                                                {translations['agreement_link_not_clicked_error']}
                                            </p>
                                        )}
                                    </div>
                                )}

                                <button type="button" className="payment-actions-acquire-button"
                                        onClick={handleAcquireClick}>
                                    {translations['payment_acquire_button']}
                                </button>
                            </section>
                        </>
                    )}

                    {shouldDisplayLoader && (
                        <Loader
                            className={combineClassNames('popup-loader', isProcessing && 'popup-loader_darken-screen')}/>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NewPaymentPopup;


const PaymentDetailsTotalSaved = ({isCentered, replacementsObject, text}) => (
    <div
        className={combineClassNames(
            'payment-details-total-saved',
            isCentered && 'payment-details-total-saved_centered',
        )}
    >
        <img src={percentageTagIcon} alt="Total Saved Icon" className="total-saved-icon"/>
        <p className="total-saved-label">
            {interpolate(text, replacementsObject)}
        </p>


    </div>
);
